var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraIos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 113,
    viewBox: "0 0 157 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1642_4392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.677 41.6924C112.157 42.0975 102.974 47.2924 102.974 58.8437C102.974 72.2047 114.659 76.9314 115.009 77.0484C114.955 77.3366 113.153 83.5219 108.848 89.8242C105.01 95.3702 101.001 100.907 94.9026 100.907C88.8043 100.907 87.2349 97.351 80.195 97.351C73.3344 97.351 70.8951 101.024 65.317 101.024C59.7388 101.024 55.8467 95.8924 51.3716 89.5901C46.1881 82.1894 42 70.6921 42 59.7801C42 42.2776 53.3356 32.9951 64.4919 32.9951C70.4198 32.9951 75.3612 36.9026 79.0829 36.9026C82.6253 36.9026 88.1496 32.7611 94.8936 32.7611C97.4495 32.7611 106.633 32.9951 112.677 41.6924ZM91.692 25.3513C94.4811 22.0291 96.4541 17.4194 96.4541 12.8097C96.4541 12.1704 96.4002 11.5222 96.2837 11C91.7458 11.1711 86.3471 14.0341 83.0916 17.8245C80.5358 20.7416 78.1502 25.3513 78.1502 30.024C78.1502 30.7263 78.2668 31.4286 78.3206 31.6536C78.6076 31.7077 79.074 31.7707 79.5403 31.7707C83.6118 31.7707 88.7326 29.0337 91.692 25.3513Z",
    fill: "url(#paint0_linear_1642_4392)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1642_4392",
    x1: 42,
    y1: 11,
    x2: 129.282,
    y2: 83.9471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E3DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1642_4392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 90.0333,
    fill: "white",
    transform: "translate(42 11)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraIos);
export default __webpack_public_path__ + "static/media/GraIOS.c961adae68f7c397187c8411bf2ceb93.svg";
export { ForwardRef as ReactComponent };